import {Box, Button, Card, Grid, Typography} from "@mui/material";
import MetaList from "./MetaList";

function NewsCard({
    title,
    image,
    imageAlt = "",
    imagePosition = "left",
    endDate,
    body,
    meta,
    ctaLabel,
    onCtaClick,
}) {
    if (endDate && new Date() >= endDate) return null;

    const imageOrder = imagePosition === "left" ? {xs: 1, md: 1} : {xs: 1, md: 2};
    const textOrder = imagePosition === "left" ? {xs: 2, md: 2} : {xs: 2, md: 1};

    return (
        <Card
            elevation={2}
            sx={{
                overflow: 'hidden',
                mb: {xs: 4, md: 5},
            }}
        >
            <Grid container alignItems="stretch">
                <Grid item xs={12} md={6} order={imageOrder}>
                    <Box
                        component="img"
                        src={image}
                        alt={imageAlt}
                        sx={{
                            display: 'block',
                            width: '100%',
                            height: '100%',
                            minHeight: {md: 320},
                            maxHeight: {xs: 360, md: 'none'},
                            objectFit: 'cover',
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={6} order={textOrder}>
                    <Box sx={{p: {xs: 3, md: 4}, display: 'flex', flexDirection: 'column', height: '100%'}}>
                        <Typography variant="h5" component="h3" sx={{fontWeight: 700, mb: 1.5}}>
                            {title}
                        </Typography>
                        {body && (
                            <Typography sx={{lineHeight: 1.6, color: 'text.secondary'}}>
                                {body}
                            </Typography>
                        )}
                        {meta && meta.length > 0 && <MetaList items={meta}/>}
                        {ctaLabel && onCtaClick && (
                            <Box sx={{pt: 3}}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={onCtaClick}
                                    sx={{color: 'onPrimary.main'}}
                                >
                                    {ctaLabel}
                                </Button>
                            </Box>
                        )}
                    </Box>
                </Grid>
            </Grid>
        </Card>
    );
}

export default NewsCard;
